var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 24.5,
    r: 21.5,
    fill: "#3347E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 3C14.6483 3 5 12.6479 5 24.5C5 36.3517 14.6479 46 26.5 46C38.3517 46 48 36.3521 48 24.5C48 12.6483 38.3517 3 26.5 3ZM26.5 9.71848C30.9478 9.71848 34.5624 13.3331 34.5624 17.7808C34.5624 22.2286 30.9478 25.8432 26.5 25.8432C22.0522 25.8432 18.4376 22.2286 18.4376 17.7808C18.4376 13.3331 22.0522 9.71848 26.5 9.71848ZM40.7036 34.6312C37.4385 39.2265 32.1305 41.9678 26.5 41.9678C20.8695 41.9678 15.5618 39.2265 12.2964 34.6312C11.9068 34.0935 11.9738 33.3548 12.444 32.8842C16.2335 29.216 21.2186 27.187 26.5001 27.187C29.8191 27.187 33.0976 28.0067 35.9734 29.5521C37.6529 30.4389 39.1983 31.5677 40.5557 32.8981C41.0259 33.3547 41.0929 34.094 40.7033 34.6312H40.7036Z",
    fill: "#D3D6DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.ad1463db6a280aab6134493d69892165.svg";
export { ForwardRef as ReactComponent };